<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import URL from '@/api/im/url'
  import Qs from 'qs'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  let effect = {1:"有效",2:"无效"}
  let intention = {1:"高",2:"中",3:"低",4:"无"}
  let type = {0:"真实",1:"模拟",2:"游客"}
  let title = {"0081":"先生","0082":"女士","0083":"太太","0084":"小姐"}
  let nationality = { 'ISO_3166_704': '越南', 'ISO_3166_356': '印度' }
  let callType = {1:"电话",2:"Zalb",3:"IM"}
  let userList = {}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
    },
    mounted() {
      this.axios.post(URL.call.customer.getServiceUser,  {pageNum: 1, pageSize: 1000},{headers:{'Content-Type': 'application/json'}}).then(res => {
        //console.log(res);
        if (res.code == 0 && res.result){
          let arr = res.result.list;
          for (let i in arr) {
            userList[arr[i].userName] = arr[i].displayName;
          }
        }
      })
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            { title: '用户账号', field: 'customerNumber',data:this.$route.query.customerNumber},
            { title: '手机号', field: 'mobilePhone'},
            { title: '开始时间', field: 'startCreateTime',type:5},
            { title: '结束时间', field: 'endCreateTime',type:5},
            {click:"查询"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.call.customercall.list, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
              /*{ title: 'id', field: 'id'},*/
              { title: '用户账号', field: 'customerNumber'},
              { title: '平台', field: 'platform'},
              { title: '业务组', field: 'businessType'},
              { title: '手机区号', field: 'mobilePhonePrefix'},
              { title: '手机号', field: 'mobilePhone'},
              { title: '英文名', field: 'englishFirstName'},
              { title: '英文姓', field: 'englishLastName'},
              { title: '类型', field: 'type',render:(data,full)=>{
                  return type[data];
                }},
              { title: '国籍', field: 'nationality',render:(data,full)=>{
                  return nationality[data];
                }},
              { title: '性别', field: 'title',render:(data,full)=>{
                  return title[data];
                }},
              { title: '归属客服', field: 'serviceUserName',render:(data,full)=>{
                  return userList[data];
                }},
              { title: '联系方式', field: 'callType',render:(data,full)=>{
                return callType[data];
              }},
              { title: '分机', field: 'extension'},
              { title: '拨打线路', field: 'callPrefix'},
              { title: '真实拨打手机号', field: 'callPhone'},
             /* { title: '显示的呼叫号码', field: 'callerId'},*/
              { title: '通话标识', field: 'callUniqueid'},
              { title: '通话标题', field: 'callTitle'},
              { title: '是否有效', field: 'effect',render:(data,full)=>{
                  return effect[data];
                }},
              { title: '意向度', field: 'intention',render:(data,full)=>{
                  return intention[data];
                }},
              { title: '备注', field: 'remark'},
              { title: '入库时间', field: 'createTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},

          ]
        }
      }
    }
  }
</script>
